import styled from 'styled-components';

export const SummaryWrapper = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px 0 rgba(25,51,77,0.06);
`;

export const SummaryTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 700;
  color: #223046;
  margin: 4px 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const KPIGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 14px;
`;

export const KPICard = styled.div`
  background: #FFFCF4;
  border: 1.5px solid #F3F4F6;
  border-radius: 10px;
  padding: 12px;
  text-align: center;
`;

export const KPILabel = styled.div`
  font-size: 0.9rem;
  color: #6B7280;
`;

export const KPINumber = styled.div`
  font-size: 1.8rem;
  font-weight: 800;
  color: #223046;
`;

export const InfoList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
`;

export const InfoItem = styled.div`
  background: #F8FAFC;
  border: 1.5px solid #E7EAEE;
  border-radius: 10px;
  padding: 10px 12px;
  color: #223046;
`;

export const GPACard = styled.div`
  background: linear-gradient(180deg, #294466 0%, #223046 100%);
  color: #fff;
  border-radius: 10px;
  padding: 16px 12px;
  text-align: center;
  margin-bottom: 14px;
  font-weight: 700;
`;

export const ProgressBar = styled.div`
  height: 6px;
  background: #E7EAEE;
  border-radius: 6px;
  overflow: hidden;
  > div {
    height: 100%;
    background: linear-gradient(90deg, #223046 60%, #7B2639 100%);
  }
`;


